<template>
  <vue-final-modal v-slot="{ close }">
    <div class="loginmodal">
      <div class="art" :class="level"><!-- agreeart warningart -->
        <!--span class="img"></span-->
        <p v-html="$t(code)"></p>
        <div class="btn">
          <template v-if="type == 'confirm'">
            <button class="yes" @click="$emit('confirm', 'yes', close)">{{$t('front.button.yes')}}</button>
            <button class="no" @click="$emit('confirm', 'no', close)">{{$t('front.button.no')}}</button>
          </template>

          <template v-if="type == 'check'">
            <button class="yes" @click="$emit('check', 'ok', close)">{{$t('front.button.confirm')}}</button>
          </template>
        </div>
        <button class="closeart" @click="onClose(close)"><img src="@/assets/img/icon_x.svg" /></button>
      </div>
    </div>
  </vue-final-modal>

</template>

<script>

export default {
  name: 'Alert',
  props: {
    code: {
      type: String
    },
    type: {
      type: String
    },
    level: {
      type: String,
      default: 'warningart'
    }
  },
  data () {
    return {
      lang: 'ko',
      result: ''
    }
  },
  methods: {
    onClose (close) {
      close()
      // this.$emit('close', this.type, this.result)
    }
  }
}
</script>

<style scoped>
button {cursor: pointer;}
.loginmodal {padding: 24px;box-sizing: border-box;background: rgba(3, 2, 7, .82) !important;backdrop-filter: blur(8px);}
.art {position: relative;width: min(448px, calc(100vw - 48px));margin: 0 auto;padding: 42px 34px 28px;box-sizing: border-box;text-align: left;border: 1px solid rgba(172, 70, 115, .48);border-radius: 14px;background: #0c0910;box-shadow: 0 26px 70px rgba(0, 0, 0, .62), inset 0 1px 0 rgba(255, 255, 255, .025);}
.art p {margin: 0;padding-right: 28px;font-size: 15px;font-weight: 600;letter-spacing: -.025em;color: rgba(255, 255, 255, .86);line-height: 1.55em;}
.art .btn {display: flex;justify-content: flex-end;gap: 8px;margin-top: 28px;}
.art .yes, .art .no {width: 112px;height: 40px;box-sizing: border-box;border-radius: 6px;font-size: 14px;font-weight: 700;letter-spacing: -.02em;transition: border-color .18s, background-color .18s, transform .18s;}
.art .yes {color: #fff;border: 1px solid #c34a82;border-top-color: #dd70a2;border-bottom-color: #7b1f4a;background: #aa3269;box-shadow: inset 0 1px 0 rgba(255, 255, 255, .12), 0 8px 18px rgba(107, 20, 61, .22);}
.art .yes:hover {background: #b83a73;}
.art .no {color: rgba(255, 255, 255, .72);border: 1px solid rgba(164, 121, 143, .3);background: #181219;}
.art .no:hover {border-color: rgba(205, 112, 155, .46);background: #21151d;}
.art .yes:active, .art .no:active {transform: translateY(1px);}
.closeart {width: 30px;height: 30px;padding: 6px;background: none;border: 0;position: absolute;right: 12px;top: 12px;box-sizing: border-box;opacity: .6;transition: opacity .18s;}
.closeart:hover {opacity: 1;}
.closeart img {display: block;width: 100%;height: 100%;object-fit: contain;filter: brightness(0) invert(1);}
</style>
<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
